var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class CustomersApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'customers';
    }
    getCustomers(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            var _a, _b, _c, _d, _e, _f;
            const _params = Object.assign(Object.assign({}, params), { ids: (_b = (_a = params === null || params === void 0 ? void 0 : params.ids) === null || _a === void 0 ? void 0 : _a.join(',')) !== null && _b !== void 0 ? _b : undefined, domains: (_d = (_c = params === null || params === void 0 ? void 0 : params.domains) === null || _c === void 0 ? void 0 : _c.join(',')) !== null && _d !== void 0 ? _d : undefined, approver: (_f = (_e = params === null || params === void 0 ? void 0 : params.approver) === null || _e === void 0 ? void 0 : _e.join(',')) !== null && _f !== void 0 ? _f : undefined });
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}`, params: _params }, options));
        });
    }
    getPaymentsCustomers(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/payments`,
                params: Object.assign({}, params),
            });
            return response;
        });
    }
    getPaymentsCustomer(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.accountId && !params.stripeCustomerId && !params.id) {
                throw new Error('getPaymentsCustomer requires at least one of follwing params: accountId | stripeCustomerId | id');
            }
            const response = yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/payments`,
                params: Object.assign({}, params),
            });
            const customer = response.data[0];
            return customer ? customer : null;
        });
    }
    createCustomer(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data,
            });
        });
    }
    updateCustomer(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                },
                data,
            });
        });
    }
    deleteCustomer(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, softDelete = true) {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                    softDelete: softDelete,
                },
            });
        });
    }
    chunk(arr, size) {
        const out = [];
        for (let i = 0; i < arr.length; i += size)
            out.push(arr.slice(i, i + size));
        return out;
    }
    getCustomersByIdsChunked(ids_1) {
        return __awaiter(this, arguments, void 0, function* (ids, options = {}, chunkSize = 50) {
            const unique = Array.from(new Set((ids !== null && ids !== void 0 ? ids : []).filter(Boolean)));
            if (!unique.length) {
                return { data: [] };
            }
            const chunks = this.chunk(unique, Math.max(1, chunkSize));
            const calls = chunks.map((c) => this.getCustomers({ ids: c }, options));
            const results = yield Promise.all(calls);
            const all = results.flatMap((r) => { var _a; return (_a = r.data) !== null && _a !== void 0 ? _a : []; });
            const dedup = Array.from(new Map(all.map((c) => [c.id, c])).values());
            return { data: dedup };
        });
    }
}
//# sourceMappingURL=index.js.map